import { render, staticRenderFns } from "./UIDirectSell.vue?vue&type=template&id=256bfc64&"
import script from "./UIDirectSell.vue?vue&type=script&lang=js&"
export * from "./UIDirectSell.vue?vue&type=script&lang=js&"
import style0 from "./UIDirectSell.vue?vue&type=style&index=0&id=256bfc64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports